class tokenRegister {

    static token = null;

    static setToken(token){
        tokenRegister.token = token;
        try {
            sessionStorage.setItem('token', token);
        }catch (e) {}
    }

    static getToken(){
        try {
            if(sessionStorage.getItem('token')){
                return sessionStorage.getItem('token');
            }else{
                return tokenRegister.token;
            }
        }catch (e) {
            return tokenRegister.token;
        }
    }

    static removeToken(){
        tokenRegister.token = null;
        try {
            sessionStorage.removeItem('token');
        }catch (e) {}
    }

    //SHORTENER
    static set(token){
        tokenRegister.setToken(token);
    }

    static get(){
        return tokenRegister.getToken();
    }

    static remove(){
        tokenRegister.removeToken();
    }

}

export {tokenRegister}


// WEBPACK FOOTER //
// ./src/services/tokenRegister.js